//const backendDomain = "http://192.168.1.190/sgu_accounts";
//const backendDomain = "http://192.168.1.254/oakya_dev/sguaccounts/api"
const backendDomain = "https://oakyasguaccounts.sanjayghodawat.co.in/api"

const SummaryApi = {
  createStudent: {
    url: `${backendDomain}/student/student_create.php`,
    method: "POST",
  },
  updateStudent: {
    url: `${backendDomain}/student/student_update.php`,
    method: "POST",
  },
  getAllStudents: {
    url: `${backendDomain}/student/student_retrieve.php`,
    method: "GET",
  },
  getstudentbyId: {
    url: `${backendDomain}/student/student_retrieve.php`,
    method: "POST",
  },
  getAllTodayStudents: {
    url: `${backendDomain}/student/student_admin_retrieve.php`,
    method: "GET",
  },

  paymentCreate: {  // ← CHANGED from 'paymentcreate' to 'paymentCreate'
    url: `${backendDomain}/student_payment/payment_create.php`,
    method: "POST",
  },

  getpaymentallhistory: {  // ← CHANGED from 'paymentcreate' to 'paymentCreate'
    url: `${backendDomain}/student_payment/payment_retrieve.php`,
    method: "PUT",
  },
  getpaymentbyid: {  // ← CHANGED from 'paymentcreate' to 'paymentCreate'
    url: `${backendDomain}/student_payment/payment_retrieve.php`,
    method: "POST",
  },
};

export default SummaryApi;
